import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {TextField} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const DropDown = ({SelectProps = {}, InputProps, size, ...props}) => {
  const selectProps = {
    IconComponent: ExpandMoreIcon,
    autoWidth: true,
    ...SelectProps,
  };

  return (
    <TextField
      select
      fullWidth
      variant="outlined"
      margin="normal"
      size={size === 'xsmall' ? 'small' : size}
      {...props}
      slotProps={{
        input: {sx: {fontSize: size === 'xsmall' ? 14 : 16}, ...InputProps},
        select: selectProps,
      }}
    />
  );
};

DropDown.propTypes = {
  SelectProps: PropTypes.object,
  InputProps: PropTypes.object,
  margin: PropTypes.string,
  size: PropTypes.string,
};

export default DropDown;
